<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../../canadas/casas/maplocation/SubMain'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>